// Mensagem legível de um erro da API. O FastAPI devolve `detail` como texto ou, nos erros de validação (422), como uma
// lista de objetos {type, loc, msg, input, url}. Um objeto não pode ir para o ecrã: o React rebenta a página inteira
// (no iPhone ficava tudo preto ao carregar um documento).
export function textoDoDetalhe(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === "string") return d;
        const campo = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
        const msg = d?.msg || "valor inválido";
        return campo ? `${campo}: ${msg}` : msg;
      })
      .join("; ");
  }
  if (detail && typeof detail === "object") return detail.msg || detail.message || JSON.stringify(detail);
  return "";
}

export function mensagemDeErro(e, alternativa = "Não foi possível concluir.") {
  const doServidor = textoDoDetalhe(e?.response?.data?.detail);
  if (doServidor) return doServidor;
  // Erro local (não veio do servidor), por exemplo «Não foi possível ler o ficheiro»: a mensagem já é para o utilizador
  if (!e?.response && !e?.isAxiosError && typeof e?.message === "string" && e.message) return e.message;
  return alternativa;
}
